export const APP_VERSION = '9.9.21'
export const BUILD_NUMBER = 202608140746
export const MIN_BACKEND_VERSION = '9.9.19'
export const UPDATE_CHANNEL = 'production'
